import { useEffect } from "react";
import firebase from "datastore/database";
import { isNil, omitBy } from "lodash";
import UAParser from "ua-parser-js";

import { useQueryParam } from "common/hooks";
import { useBusinessUid } from "common/hooks";
import useParams from "reducers/hooks/useParams";

const removeNil = (obj) => omitBy(obj, isNil);

function getUserAgent() {
  if (typeof navigator !== "undefined" && navigator.userAgent) {
    return navigator.userAgent;
  } else {
    return null;
  }
}

function getUserAgentInfo() {
  const userAgent = getUserAgent();
  if (!userAgent) return null;

  const parser = new UAParser(userAgent);
  const browser = removeNil(parser.getBrowser());
  const cpu = removeNil(parser.getCPU());
  const device = removeNil(parser.getDevice());
  const engine = removeNil(parser.getEngine());
  const os = removeNil(parser.getOS());
  const ua = parser.getUA();

  return {
    browser,
    cpu,
    device,
    engine,
    os,
    ua,
  };
}

async function getLocationData() {
  const locationData = localStorage.getItem("locationData");
  if (locationData) return JSON.parse(locationData);

  try {
    const response = await fetch("https://ipinfo.io/json?token=2dfea51eff7728");
    const data = await response.json();
    localStorage.setItem("locationData", JSON.stringify(data));
    return JSON.parse(data);
  } catch (error) {
    console.error("Error fetching location data: ", error);
  }
}

async function fetchData() {
  const url = window.location.href;
  let customer = JSON.parse(localStorage.getItem("resto-guru-customer"));
  if (!customer?.name && !customer?.email && !customer?.phone) customer = null;
  const userAgent = getUserAgentInfo();
  const location = await getLocationData();
  return {
    createdAt: new Date(),
    ...(customer && { customer }),
    ...(location && { location }),
    url,
    userAgent,
  };
}

async function logPageView(businessUid, refId) {
  const data = await fetchData();
  // Convert to new API
  await firebase
    .firestore()
    .collection(`page-views/business/${businessUid}`)
    .add({
      ...data,
      refId,
    });
}

export default function useLogPageView() {
  const businessUid = useBusinessUid();
  const [refId] = useQueryParam("ref");

  useEffect(() => {
    if (businessUid && refId) logPageView(businessUid, refId);
  }, [businessUid, refId]);
}
